import { Box, SectionHelper, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { RuleFooter } from '@wix/rules-panel-ui';
import { assertNotOptional } from '@wix/seo-common-core';
import React from 'react';
import { BiCtaNames } from '../../../bi/types';
import { usePanelStateAtom } from '../../../hooks/rules-state';
import { useA11yWizardAdapter } from '../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useGlobalSectionState } from '../../../rule-mappers/shared/use-global-section-state';
import { useVerify } from '../../../rule-mappers/shared/use-verify';
import { useCollapseClose } from '../../wizard-content/content-results/card-groups/lists/context/collapse-actions-context';
export const HeadingStructureRuleNoHeadings = _ref => {
  let {
    pageId
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const compactPanelChrome = capabilities.compactPanelChrome;
  const biLogger = useBiLogger();
  const closeSelf = useCollapseClose();
  const {
    verify
  } = useVerify({});
  const {
    getGroupData,
    panelState
  } = usePanelStateAtom();
  const {
    getGlobalSectionModifiedComponentIds
  } = useGlobalSectionState();
  const groupData = getGroupData(pageId);
  const handleVerify = async () => {
    biLogger.ctaClick({
      ctaName: BiCtaNames.Apply
    });
    assertNotOptional(groupData, 'groupData');
    await verify(groupData, getGlobalSectionModifiedComponentIds(panelState.globalSectionComponentsDataMap));
  };
  const handleCancel = () => {
    biLogger.ctaClick({
      ctaName: BiCtaNames.Cancel
    });
    closeSelf();
  };
  const sectionHelperProps = {
    showPrefixIcon: compactPanelChrome,
    size: compactPanelChrome ? 'small' : undefined
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(SectionHelper, sectionHelperProps, /*#__PURE__*/React.createElement(Box, {
    padding: "0 4px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      bold: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold",
        secondary: true
      }),
      underline: /*#__PURE__*/React.createElement(TextButton, {
        size: "tiny",
        skin: "dark",
        underline: "always",
        onClick: handleVerify
      })
    },
    i18nKey: "accessibility-wizard.rules-list.heading-definition.no-headings.section-helper-content",
    t: t
  })))), compactPanelChrome && /*#__PURE__*/React.createElement(Box, {
    align: "right",
    marginTop: "SP2",
    width: "100%"
  }, /*#__PURE__*/React.createElement(RuleFooter, {
    design: {
      buttonSize: 'small'
    },
    dismissButtonProps: {
      label: t('accessibility-wizard.rules-list.heading-definition.no-headings.secondary-button'),
      onClick: handleCancel,
      type: 'button'
    },
    submitButtonProps: {
      label: t('accessibility-wizard.rules-list.heading-definition.no-headings.primary-button'),
      onClick: handleVerify
    }
  })));
};
//# sourceMappingURL=heading-structure-rule-no-headings.js.map